import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { ReactNode } from 'react';
import Divider from '../Divider';
import styles from './formula-card.module.scss';

export type FormulaCardProps = {
    title?: string;
    list: Array<string>;
    subtitle: string;
    highlight: string | ReactNode;
    caption?: string;
    className?: string;
};

const FormulaCard = ({
    title,
    list,
    subtitle,
    caption,
    highlight,
    className,
}: FormulaCardProps) => {
    return (
        <div className={classNames(styles['wrapper'], className)}>
            {title ? (
                <>
                    <h4>{title}</h4>
                    <Divider margin={0} />
                </>
            ) : null}
            <small className={styles['targeting']}>Targeting</small>
            <ul>
                {list.map((l, i) => (
                    <li key={i}>
                        <FontAwesomeIcon
                            icon={faCheck}
                            width={14}
                            height={14}
                        />
                        {l}
                    </li>
                ))}
            </ul>
            <Divider margin={0} />
            <div className={styles['container']}>
                <small className={styles['subtitle']}>{subtitle}</small>
                {typeof highlight === 'string' ? (
                    <span>{highlight}</span>
                ) : (
                    highlight
                )}
                {caption ? <small>{caption}</small> : null}
            </div>
        </div>
    );
};

export default FormulaCard;
